import { render, staticRenderFns } from "./EditBordereauModal.vue?vue&type=template&id=4f2bd30c&scoped=true&"
import script from "./EditBordereauModal.vue?vue&type=script&lang=js&"
export * from "./EditBordereauModal.vue?vue&type=script&lang=js&"
import style0 from "./EditBordereauModal.vue?vue&type=style&index=0&id=4f2bd30c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2bd30c",
  null
  
)

export default component.exports